module.exports = "/_next/static/images/Privacy-md-483994f56e0afc0e26cfbdf0afab9d78.webp";